import ReactGA from 'react-ga';

import { /* knownRoutes as routes, */ analyticsBlackList } from '../../routes';
import debug from '../../lib/debug';

const unique = (arr = []) => [...new Set(arr)];

const AnalyticsPageView = () => {
  const { REACT_APP_GA_ACCOUNT_ID: gaAccountId } = process.env;

  if (!gaAccountId) {
    return null;
  }

  const logGAPageView = debug({ src: 'components/AnalyticsPageView/AnalyticsPageView' });

  const doNotTrackPaths = unique([
    // Seems pointless to track redirects, need to determine value before allowing
    // ...(routes || []).filter(rte => !!rte.redirect || !rte.redirectWithParams).map(rte => rte.path),
    ...analyticsBlackList, // Add any globally blacklisted paths
    ...[
      /* insert custom do not track paths here */
    ],
    '/callback',
    '/shopify/callback',
  ]);

  const { location: { pathname: page } } = window;

  if (doNotTrackPaths.indexOf(page.toLowerCase()) > -1) {
    logGAPageView(`🙌 Ignoring page view (do not track): ${page}`);

    return null;
  }

  ReactGA.set({ page });
  ReactGA.pageview(page);

  logGAPageView(`📝 Tracked page view for ${page}`);

  return null;
};

export default AnalyticsPageView;



// WEBPACK FOOTER //
// ./src/components/Analytics/AnalyticsPageView.js